var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{class:_vm.$vuetify.breakpoint.width < 600
		  ? 'd-flex flex-column align-center'
		  : 'd-flex justify-space-between pl-12',attrs:{"color":"appGrey","elevation":"2"}},[_c('v-img',{attrs:{"src":require('@/assets/images/vindico-logo-purple.png'),"contain":"","height":"16","max-width":"128"}}),_c('app-text',{attrs:{"color":"grey9","size":"small"}},[_vm._v(" Copyright "),_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.appConfig.appBranding.companyName))]),_vm._v(" 2023 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }